<script setup>
const props = defineProps({
    anchorId: {
        type: String,
        required: false,
        default: '',
    },
    code: {
        type: String,
        required: true,
    },
    attributes: {
        type: Object,
        default: () => ({}),
    },
});

const removeScriptTags = (html) => {
    return html.replace(/<script\b[^<]*(?:(?!<\/script>)<[^<]*)*<\/script>/gi, '');
};

// https://server.fillout.com/embed/v1/
const addScript = () => {
    const hasScript = document.getElementById('fillout-embed-script');
    if (!hasScript) {
        const bz = document.createElement('script');
        bz.id = 'fillout-embed-script';
        bz.type = 'text/javascript';
        bz.src = 'https://server.fillout.com/embed/v1/';
        const s = document.getElementsByTagName('script')[0];
        document.head.appendChild(bz);
    }
};

useNuxtApp().hook('page:finish', () => {
    const script = document.getElementById('fillout-embed-script');
    if (script) { script.remove(); }
    setTimeout(() => { addScript(); }, 16);
});

onMounted(() => {
    addScript();
    const hasScript = document.getElementById('fillout-embed-script');
    if (hasScript) {
        setTimeout(() => { hasScript.remove(); }, 16);
    }
});
</script>

<template>
    <section :id="anchorId" class="block block-fillout">
        <ClientOnly>
            <div v-html="removeScriptTags(code)"></div>
        </ClientOnly>
    </section>
</template>
<style lang="scss">
.block-fillout {
    padding: 0;
    background: var(--gray-100);
}
</style>
